import axiosInstance from '../../services/axiosInstance';
import { PptxImportResult, PptxPreviewResult, PptxTargetField } from './types';

const BASE_URL = '/api/pptx-template-field-import';

function buildImportFormData(file: File, targetField: string): FormData {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('targetField', targetField);
  return formData;
}

export async function fetchPptxTargetFields(): Promise<PptxTargetField[]> {
  const { data } = await axiosInstance.get<PptxTargetField[]>(`${BASE_URL}/target-fields`);
  return data;
}

export async function previewPptxTemplateFieldImport(file: File, targetField: string): Promise<PptxPreviewResult> {
  const { data } = await axiosInstance.post<PptxPreviewResult>(
    `${BASE_URL}/preview`,
    buildImportFormData(file, targetField),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
}

export async function runPptxTemplateFieldImport(file: File, targetField: string): Promise<PptxImportResult> {
  const { data } = await axiosInstance.post<PptxImportResult>(
    `${BASE_URL}/import`,
    buildImportFormData(file, targetField),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
}
